module.exports = __webpack_public_path__ + "static/media/user.e1fc3041.svg";